// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = 'LCPv1,%R+SJmV(RV3VQa3%_X[!%@B,b-tZQagc_479%SH!y-86y:zSL,S6neo!>3[pJ+ZcL@_:<S[:7ak:L@V(oa-coc@:+R$SjFX(+r@Votycie:IjXoeiE4VJek!%+_I<a47+tFI%<[(RdR2Y38(jyJpLtB!naNVLy8cHdd>RrJ>+-+(JtR(7cmkiR<SQ466_!va++62gF!p1F$Ii-:p1<<aQ-:6_@QaQd@>%X<2p@6p<-)!jyQaNRQpg!F6<4$27y@G<-6p<dQI%!:aQ!)27@QI%4v>jzvaj@F>jyQ>N-v2%-QI<4:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll';
